import normalizeFiles from './normilizeFiles';

export default normalizeFiles([
  {
    title: 'title',
    url: 'http://shiz.co/beatlescode/assets/hereComesTheSun.mp3',
    size: 10000,
  },
  {
    url: 'http://shiz.co/beatlescode/assets/hereComesTheSun.mp3',
  },
  'https://platform.incircle.co.uk/storage/5c9a8cf1bc6a0d0014350b26/1554025768348_266.pdf',
  'https://i.imgur.com/7UGNCWK.jpg',
  {
    url: 'http://shiz.co/beatlescode/assets/hereComesTheSun.mp3',
    size: 2099,
  },
  'http://techslides.com/demos/sample-videos/small.mp4',
  {
    url: 'http://www.snee.com/xml/xslt/sample.doc',
    title: 'title 2',
    size: 10000,
  },
  'https://www.cmu.edu/blackboard/files/evaluate/tests-example.xls',
  'https://www.w3.org/TR/PNG/iso_8859-1.txt',
  'https://google.com',
]);
